
/* injects from baggage-loader */

'use strict';

import pendingToConfirmTemplate from './pendingToConfirm.html';

/**
* Function that register the all routes for the pendingToConfirm module.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @param {any} routerHelper
*/
function routeConfig($q, $ocLazyLoad, routerHelper, navigationConstant) {
	'ngInject';

	/**
	* Route definition of the pendingToConfirm page.
	*/
	const indexNav = 6;
	const indexSubmenu = 3;
	const pendingToConfirmRoute = {
		state: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].STATE,
		config: {
			url: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].URL,
			templateUrl: pendingToConfirmTemplate,
			controller: 'PendingToConfirmController',
			controllerAs: 'pendingToConfirmvm',
			resolve: {
				pendingToConfirm: pendingToConfirmLazyLoading
			},
			data: {
				code: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].CODE,
				login: true,
				pageTitle: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].NAME,
				submenu: true
			},
		}
	}

	routerHelper.configureStates([pendingToConfirmRoute]);
}

/**
* Function for the lazyLoading configuration in the pendingToConfrim route.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @returns
*/
function pendingToConfirmLazyLoading($q, $ocLazyLoad) {
	'ngInject';

	const deferred = $q.defer();

	require.ensure([], require => {
		const pendingToConfirmModule = require('./pendingToConfirm.module');

		$ocLazyLoad.load({
			name: pendingToConfirmModule.default.name,
		});

		deferred.resolve(pendingToConfirmModule.default.controller);
	});

	return deferred.promise;
}

export default angular
	.module('pendingToConfirm.routes', [])
	.run(routeConfig);



// WEBPACK FOOTER //
// ./src/app/auth/components/pendingToConfirm/pendingToConfirm.routes.js